import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SearchResultViewType} from '../../core/definitions/search-result-view-type.enum';

interface ContentListViewChoice {
  name: SearchResultViewType;
  icon: string;
  description: string;
}

@Component({
  selector: 'app-content-list-view-selector',
  templateUrl: './content-list-view-selector.component.html',
  styleUrls: ['./content-list-view-selector.component.scss'],
  standalone: false
})
export class ContentListViewSelectorComponent {
  @Input() resultViewName = SearchResultViewType.CONTENT_LIST;
  @Output() viewSelected = new EventEmitter<SearchResultViewType>();

  readonly views: ContentListViewChoice[] = [
    {name: SearchResultViewType.CONTENT_LIST, icon: 'grid_view', description: 'TRANS__SEARCH__DISPLAY_CARDS'},
    {name: SearchResultViewType.LIST, icon: 'view_headline', description: 'TRANS__SEARCH__DISPLAY_WITHOUT_IMAGE'},
  ];

  get currentView(): ContentListViewChoice {
    return this.views.find(view => view.name === this.resultViewName) ?? this.views[0];
  }

  isTable(): boolean {
    return this.resultViewName === SearchResultViewType.LIST;
  }

  select(viewName: SearchResultViewType) {
    if (this.resultViewName === viewName) {
      return;
    }
    this.resultViewName = viewName;
    this.viewSelected.emit(viewName);
  }
}
